export default {
  methods: {
    preventBackOnHorizontalScroll (elem) {
      elem.addEventListener('touchmove', (event) => {
        event.preventDefault()
      }, false)
      elem.addEventListener('wheel', (event) => {
        const maxX = elem.scrollWidth - elem.offsetWidth
        const maxY = elem.scrollHeight - elem.offsetHeight
        if (elem.scrollLeft + event.deltaX < 0 ||
          this.scrollLeft + event.deltaX > maxX ||
          elem.scrollTop + event.deltaY < 0 ||
          elem.scrollTop + event.deltaY > maxY) {
          event.preventDefault()
          this.scrollLeft = Math.max(0, Math.min(maxX, elem.scrollLeft + event.deltaX))
          this.scrollTop = Math.max(0, Math.min(maxY, elem.scrollTop + event.deltaY))
        }
      }, false)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/preventBackOnHorizontalScroll.js